import React from "react";

// forwardRef para que `{...register(...)}` de react-hook-form llegue al input real.
const Checkbox = React.forwardRef(({ className = "w-fit", label, ...rest }, ref) => (
	<div className={`checkbox ${className}`}>
		<label className="container">
			<input type="checkbox" ref={ref} {...rest} />
			<span className="checkmark"></span>
			{label}
		</label>
	</div>
));

export default Checkbox;
